import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import styles from "./ForthScreen.module.css"
const ForthScreen=()=>{


return <>
<div className={styles.title} id="שאלות נפוצות" >שאלות תשובות</div>
<div className={styles.description}>אם הגעת לכאן ועדיין נותרו לך כמה שאלות.. אני כאן כדי לענות לך על כולן. לחצי על כל שאלה והתשובה תיפתח</div>
<FAQItem
  question="כבר ניסיתי קוסמטיקאיות בעבר וזה לא עבד. למה ששוב אתן אמון?"
  answer="את לא היחידה שמרגישה ככה. וזו הסיבה שחשוב לי להתחיל מבדיקה, חשוב לי להבין מה עשו לך, מה לא עשו, מה המטרה שלך. אני לא אוהבת להבטיח תוצאות סתם. תיצרי איתי קשר ונבדוק יחד איך אפשר לעזור לך"
/>

<FAQItem
  question="אני מפחדת שיכאב לי בטיפולים העור שלי רגיש. כמה זה באמת כואב?"
  answer="זה חשש לגיטימי. חשוב לי שתדעי שהיום יש אלחושים שרק בעסזרתם לא תרגישי כמעט כלום ומעבר לחומרים המאלחשים אני עובדת בעדינות, מתאממה את סגנון העבודה בהתאם לעור שלך ואגב.. יש לי לקוחות שנרדמות בטיפול, אז אני מאמינה שנסתדר :)"
/>

<FAQItem
  question="יש מלא שיטות לאיפור קבוע. איך אני יודעת מה הכי נכון לי?"
  answer="את לא צריכה לדעת. אני בודקת את סוג העור שלך, צפיפות השיער, הצבעים, ואז ממליצה מה יחזיק הכי טוב ומה ייראה טבעי. כל אחת מקבלת התאמה אישית"
/>



<FAQItem
  question="אחרי הטיפול אני יכולה להמשיך כרגיל או שזה משבית אותי?"
  answer="ברוב הטיפולים את קמה וממשיכה את היום כרגיל. אין צורך בימי מחלה או חופשה מיוחדת. זה לגמרי מותאם לשגרה"
/>

<FAQItem
  question="אחרי כמה זמן רואים תוצאות בטיפולי פנים?"
  answer="בחלק מהמקרים רואים שינוי ניכר כבר מהטיפול הראשון. כשמדובר בצלקות פוסט אקנה או אקנה דלקתי נדרש תהליך מותאם לאותו המקרה שאני מתאימה יחד איתך, עם הסבר מדוייק ומכשור ייעודי"
/>

<FAQItem
  question="יש לי עור מצולק מפצעונים. אפשר לעשות עם זה משהו?"
  answer="בוודאי. אני משתמשת בטכנולוגיה מתקדמת של RF Fractional שמטשטשת צלקות ומשפרת את מרקם העור. זו טכנולוגיה שדורשת דיוק, ואני עובדת איתה שנים"
/>

<FAQItem
  question="אם הגנטיקה שלי בעייתית, יש סיכוי שהטיפול יעזור בכלל?"
  answer="אני לא משנה גנטיקה, אבל אני יודעת לשפר עור עייף, אפרפר או מצולק. טיפולים נכונים עושים שינוי משמעותי בהרגשה ובמראה"
/>

<FAQItem
  question="חשבתי לקחת רואקוטן. זו לא דרך קלה יותר? מה הסיכונים?"
  answer="הרואקוטן היא תרופה חזקה יחסית שתעזור בחלק מהמקרים ולא לכולם. אבל צריך לקחת בחשבון את תופעות הלוואי הלא פשוטות של התרופה.
כגון יובש מוגזם של השפתיים, פנים, מצב רוח, איסור חשיפה לשמש ועוד.

עם טיפול נכון ומכשור מתאים, ניתן להגיע לתוצאות יפות, בלי פגיעה בבריאות שלך."
/>

<FAQItem
  question="יש לי אקנה פעיל ואני מתביישת בעור שלי. אפשר לטפל בזה?"
  answer="כן. אני מטפלת בהרבה לקוחות שמגיעים/ות אלי עם עור מודלק או מצולק"
/>
<Button text="לעוד שאלות לחצי כאן"/>

</>
}
export default ForthScreen